// Tiny frontend logger for production-noise control.
//
// Page-level catch blocks already render user-facing error UI (toasts,
// inline errors). The raw `console.error(err)` call next to those blocks
// only existed to help with local development — but it shipped to
// production too, and shows up in browser DevTools when a normal
// recoverable error happens (e.g. "wrong password"). That's noisy and
// can leak details we don't want surfaced to end users.
//
// Use this logger inside catch blocks instead of `console.error` /
// `console.warn` directly. It's a no-op in production builds and
// transparent in development.
//
// Sensitive values (passwords, temp passwords, invite codes, tokens,
// photo URLs, AI prompts, private mission text, full family lore)
// must NOT be passed in here even in development.
export const clientLogger = {
  error: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },
};
